import { render } from "./AdvantageAbTest.vue?vue&type=template&id=4385e43a"
import script from "./AdvantageAbTest.vue?vue&type=script&lang=js"
export * from "./AdvantageAbTest.vue?vue&type=script&lang=js"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__